export default __webpack_public_path__ + "static/media/036-flashlight.5752489d.png";